import { render, staticRenderFns } from "./studioEditor.vue?vue&type=template&id=59c1567f&scoped=true"
import script from "./studioEditor.vue?vue&type=script&lang=js"
export * from "./studioEditor.vue?vue&type=script&lang=js"
import style0 from "./studioEditor.vue?vue&type=style&index=0&id=59c1567f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c1567f",
  null
  
)

export default component.exports